/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They are two ASCII encodings of the score in FASTQ files. Phred+33 (Sanger, Illumina 1.8+) adds 33 to Q; Phred+64 (older Illumina) adds 64. The correct offset is needed to decode qualities.`)
};

const es_phred_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son dos codificaciones ASCII de la puntuación en archivos FASTQ. Phred+33 (Sanger, Illumina 1.8+) suma 33 a Q; Phred+64 (Illumina antiguo) suma 64. Se necesita el desplazamiento correcto para decodificar las calidades.`)
};

const de_phred_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es sind zwei ASCII-Kodierungen des Werts in FASTQ-Dateien. Phred+33 (Sanger, Illumina 1.8+) addiert 33 zu Q; Phred+64 (älteres Illumina) addiert 64. Der richtige Offset ist notwendig, um Qualitäten zu dekodieren.`)
};

const nl_phred_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het zijn twee ASCII-coderingen van de score in FASTQ-bestanden. Phred+33 (Sanger, Illumina 1.8+) telt 33 op bij Q; Phred+64 (oudere Illumina) telt 64 op. De juiste offset is nodig om kwaliteiten te decoderen.`)
};

const fr_phred_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce sont deux encodages ASCII du score dans les fichiers FASTQ. Phred+33 (Sanger, Illumina 1.8+) ajoute 33 à Q ; Phred+64 (ancien Illumina) ajoute 64. Le bon décalage est nécessaire pour décoder les qualités.`)
};

const it_phred_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono due codifiche ASCII del punteggio nei file FASTQ. Phred+33 (Sanger, Illumina 1.8+) aggiunge 33 a Q; Phred+64 (Illumina più vecchio) aggiunge 64. Serve l'offset corretto per decodificare le qualità.`)
};

const pt_br2_phred_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`São duas codificações ASCII do escore em arquivos FASTQ. Phred+33 (Sanger, Illumina 1.8+) soma 33 ao Q; Phred+64 (Illumina antigo) soma 64. O deslocamento correto é necessário para decodificar as qualidades.`)
};

const pt_phred_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`São duas codificações ASCII da pontuação em ficheiros FASTQ. O Phred+33 (Sanger, Illumina 1.8+) soma 33 a Q; o Phred+64 (Illumina mais antigo) soma 64. É necessário o offset correto para descodificar as qualidades.`)
};

const ja_phred_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どちらもFASTQファイルにおけるスコアの2つのASCIIエンコーディングです。Phred+33（Sanger、Illumina 1.8以降）はQに33を加え、Phred+64（古いIllumina）は64を加えます。品質を正しくデコードするには正しいオフセットが必要です。`)
};

const zh_phred_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它们是 FASTQ 文件中该分数的两种 ASCII 编码方式。Phred+33（Sanger、Illumina 1.8+）将 33 加到 Q 上；Phred+64（较旧的 Illumina）将 64 加到 Q 上。要正确解码质量值，必须使用正确的偏移量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_faq_a2", locale)
	if (locale === "en") return en_phred_faq_a2(inputs)
	if (locale === "es") return es_phred_faq_a2(inputs)
	if (locale === "de") return de_phred_faq_a2(inputs)
	if (locale === "nl") return nl_phred_faq_a2(inputs)
	if (locale === "fr") return fr_phred_faq_a2(inputs)
	if (locale === "it") return it_phred_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_phred_faq_a2(inputs)
	if (locale === "pt") return pt_phred_faq_a2(inputs)
	if (locale === "ja") return ja_phred_faq_a2(inputs)
	return zh_phred_faq_a2(inputs)
};